/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RioExportReportQueryVariables = Types.Exact<{
  reportId: Types.Scalars['ID']['input']
  language: Types.RioLanguage
}>

export type RioExportReportQuery = {
  __typename?: 'Query'
  rioExportReport: { __typename?: 'RioExportReportResponse'; url: string }
}

export const RioExportReportDocument = gql`
    query RioExportReport($reportId: ID!, $language: RioLanguage!) {
  rioExportReport(input: {reportId: $reportId, language: $language}) {
    url
  }
}
    `

/**
 * __useRioExportReportQuery__
 *
 * To run a query within a React component, call `useRioExportReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRioExportReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRioExportReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRioExportReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    RioExportReportQuery,
    RioExportReportQueryVariables
  > &
    (
      | { variables: RioExportReportQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RioExportReportQuery, RioExportReportQueryVariables>(
    RioExportReportDocument,
    options,
  )
}
export function useRioExportReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RioExportReportQuery,
    RioExportReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RioExportReportQuery,
    RioExportReportQueryVariables
  >(RioExportReportDocument, options)
}
export function useRioExportReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioExportReportQuery,
        RioExportReportQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RioExportReportQuery,
    RioExportReportQueryVariables
  >(RioExportReportDocument, options)
}
export type RioExportReportQueryHookResult = ReturnType<
  typeof useRioExportReportQuery
>
export type RioExportReportLazyQueryHookResult = ReturnType<
  typeof useRioExportReportLazyQuery
>
export type RioExportReportSuspenseQueryHookResult = ReturnType<
  typeof useRioExportReportSuspenseQuery
>
export type RioExportReportQueryResult = Apollo.QueryResult<
  RioExportReportQuery,
  RioExportReportQueryVariables
>
